<template>
    <div :v-bind:class="(results?.total > 0) ? 'py-3 flex items-center justify-between border-t border-gray-200':''">
      <div class="flex-1 flex justify-between sm:hidden">
      <inertia-link
        v-if="enablePagination"
        :href="previousLink?.url ? previousLink.url : 'javascript:void(0)'"
        :class="[
          'relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-bold rounded-md',
          previousLink ? 'text-gray-900 bg-white hover:bg-gray-50' : 'text-gray-400 bg-gray-100 cursor-not-allowed pointer-events-none'
        ]"
        :disabled="!previousLink"
      >
        « Previous
      </inertia-link>

      <div v-if="enablePagination">
        <p class="text-sm text-gray-900 font-bold leading-6 hidden sm:block">
          Showing
          {{ ' ' }}
          <span class="font-bold">{{ results?.from }}</span>
          {{ ' ' }}
          to
          {{ ' ' }}
          <span class="font-bold">{{ results?.to }}</span>
          {{ ' ' }}
          of
          {{ ' ' }}
          <span class="font-bold">{{ results?.total }}</span>
          {{ ' ' }}
          {{ type }}
        </p>
      </div>

      <inertia-link
        v-if="enablePagination"
        :href="nextLink?.url ? nextLink.url : 'javascript:void(0)'"
        class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-bold rounded-md"
        :class="nextLink ? 'text-gray-900 bg-white hover:bg-gray-50' : 'text-gray-400 bg-gray-100 cursor-not-allowed pointer-events-none'"
        :disabled="!nextLink"
      >
        Next »
      </inertia-link>
    </div>
        <div v-show="results?.total > 0" class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
            <div>
                <p class="text-sm text-gray-900 font-bold leading-6">
                    Showing
                    {{ ' ' }}
                    <span class="font-bold">{{ results?.from }}</span>
                    {{ ' ' }}
                    to
                    {{ ' ' }}
                    <span class="font-bold">{{ results?.to }}</span>
                    {{ ' ' }}
                    of
                    {{ ' ' }}
                    <span class="font-bold">{{ results?.total }}</span>
                    {{ ' ' }}
                    {{ type }}
                </p>
            </div>
            <div v-if="links.length > 3">
                <div class="flex flex-wrap -mb-1">
                    <template v-for="(link, key) in links">
                        <div v-if="link.url === null" :key="key" class="mr-1 mb-1 px-4 py-3 text-sm leading-7 text-gray-400 border rounded bg-white" v-html="link.label" />
                        <inertia-link v-else class="mr-1 mb-1 px-4 py-3 text-sm leading-7 border rounded hover:bg-rent-risk-blue-100 focus:border-rent-risk-blue-400 focus:text-indigo-500 bg-white" :class="{ 'z-10  bg-white border-rent-risk-blue-400 text-rent-risk-blue-400': link.active }" :href="link.url" v-html="link.label" />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { faChevronLeft, faChevronRight } from "@fortawesome/pro-solid-svg-icons"

export default {
    props: {
        links: Array,
        type: null,
        results: Object,
    },
    components: {
        FontAwesomeIcon,
    },
    computed: {
      previousLink() {
        return this.links ? this.links.find(link => link.label.toLowerCase().includes('previous') && link.url) : null;
      },
      nextLink() {
        return this.links ? this.links.find(link => link.label.toLowerCase().includes('next') && link.url) : null;
      },
      enablePagination() {
        return Array.isArray(this.links) && this.links.length > 3 && this.links.some(link => link.label === '2' && link.url);
      },
    },
}
</script>
